import clsx from "clsx";

import { ContentDivider } from "@atoms/contentDivider";

import classes from "./styles.module.scss";

import type { PropsWithChildren } from "react";

import type { IClassName, IRowProps } from "./types";

function Row(props: PropsWithChildren<IRowProps>) {
  const { children, className, gap, noBorder } = props;

  return (
    <>
      <div className={clsx(gap && `gap-${gap}`, className, classes.row)}>
        {children}
      </div>
      {!noBorder && <ContentDivider />}
    </>
  );
}

function Input(props: PropsWithChildren<IClassName>) {
  const { children, className } = props;

  return (
    <div className={clsx(className, classes["row-input"])}>{children}</div>
  );
}

function Field(props: PropsWithChildren<IClassName>) {
  const { children, className } = props;

  return (
    <div className={clsx(className, classes["row-field"])}>{children}</div>
  );
}

Row.Input = Input;
Row.Field = Field;
export { Row };
